module.exports = __webpack_public_path__ + "YSIIconA-8f5aace2dad34fb449b443f38d927e4c.svg";